export default "__VITE_ASSET___LDM8zLl__"